export function strlSetCookie(cname, cvalue, exdays) {
	// eslint-disable-line
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	let expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function strlGetCookie(cname) {
	// eslint-disable-line
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

export function mediaQuery(screen) {
	let styles = getComputedStyle(document.documentElement);
	let media = '';

	if ('sm' === screen) {
		media = `(max-width:${styles.getPropertyValue('--breakpoint-md')})`;
	}

	if ('md' === screen) {
		media = `(min-width:${styles.getPropertyValue('--breakpoint-md')}) and (max-width:${styles.getPropertyValue('--breakpoint-lg')})`;
	}

	if ('md-up' === screen) {
		media = `(min-width:${styles.getPropertyValue('--breakpoint-md')})`;
	}

	if ('lg' === screen) {
		media = `(min-width:${styles.getPropertyValue('--breakpoint-lg')} and (max-width:${styles.getPropertyValue('--breakpoint-xl')})`;
	}

	if ('lg-up' === screen) {
		media = `(min-width:${styles.getPropertyValue('--breakpoint-lg')})`;
	}

	if ('xl' === screen) {
		media = `(min-width:${styles.getPropertyValue('--breakpoint-xl')})`;
	}

	return media ? window.matchMedia(media).matches : false;
}

export function slideUp(target, duration = 300) {
	if (target.style.display === 'none') {
		return;
	}
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.boxSizing = 'border-box';
	target.style.height = target.offsetHeight + 'px';
	target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	window.setTimeout(() => {
		target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
		//alert("!");
	}, duration);
}

export function slideDown(target, duration = 300) {
	if (target.style.display === 'block') {
		return;
	}
	target.style.removeProperty('display');
	let display = window.getComputedStyle(target).display;

	if (display === 'none') display = 'block';

	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = 'border-box';
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.height = height + 'px';
	target.style.removeProperty('padding-top');
	target.style.removeProperty('padding-bottom');
	target.style.removeProperty('margin-top');
	target.style.removeProperty('margin-bottom');
	window.setTimeout(() => {
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	}, duration);
}

export function slideToggle(target, duration = 300) {
	if (window.getComputedStyle(target).display === 'none') {
		return slideDown(target, duration);
	} else {
		return slideUp(target, duration);
	}
}

export function animateDetails() {
	const details = document.querySelectorAll('details');
	details.forEach((detail) => {
		const content = detail.querySelector('.details-content');
		if (content) {
			detail.classList.add('cursor-pointer');
			detail.setAttribute('open', '');
			content.classList.add('hidden');
			detail.addEventListener('click', function (e) {
				e.preventDefault();
				slideToggle(content);
				detail.classList.toggle('open');
			});
		}
	});
}

export function isDomain(url, domain) {
	url = new URL(url);
	return url.hostname === domain || url.hostname.endsWith('.' + domain);
}

export function handleExternalLinks(items) {
	items.forEach((item) => {
		const url = item?.getAttribute('href');
		if (!isDomain(url, location.hostname)) {
			const icon = document.createElement('i');
			icon.setAttribute('class', 'fa-regular fa-external-link no-rotate');
			item.appendChild(icon);
			item.setAttribute('target', '_blank');
		}
	});
}

const STRL_SANITIZE_ALLOWED_TAGS = new Set([
	'a',
	'b',
	'blockquote',
	'br',
	'cite',
	'code',
	'dd',
	'del',
	'div',
	'dl',
	'dt',
	'em',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'hr',
	'i',
	'iframe',
	'img',
	'ins',
	'li',
	'mark',
	'ol',
	'p',
	'pre',
	's',
	'span',
	'strong',
	'sub',
	'sup',
	'table',
	'tbody',
	'td',
	'tfoot',
	'th',
	'thead',
	'tr',
	'u',
	'ul',
]);

const STRL_SANITIZE_URI_ATTRS = new Set(['href', 'src', 'cite', 'poster']);
const STRL_SANITIZE_GLOBAL_ATTRS = new Set(['class', 'id', 'title', 'lang', 'dir']);
const STRL_SANITIZE_TAG_ATTRS = {
	a: ['href', 'target', 'rel'],
	iframe: ['src', 'title', 'allow', 'allowfullscreen', 'loading', 'referrerpolicy'],
	img: ['src', 'alt', 'width', 'height', 'loading', 'srcset', 'sizes'],
	td: ['colspan', 'rowspan'],
	th: ['colspan', 'rowspan', 'scope'],
};

function strl_sanitize_is_safe_url(url) {
	const value = String(url).trim().replace(/[\u0000-\u001F\u007F\s]+/g, '').toLowerCase();
	if (!value) {
		return false;
	}
	if (value.startsWith('#')) {
		return true;
	}
	if (value.startsWith('mailto:') || value.startsWith('tel:')) {
		return true;
	}
	if (value.startsWith('//')) {
		return true;
	}
	if (/^(javascript|data|vbscript):/.test(value)) {
		return false;
	}
	return /^(https?:\/\/|\/|\.\/|\.\.\/)/.test(value);
}

function strl_sanitize_is_allowed_iframe_src(url) {
	if (!strl_sanitize_is_safe_url(url)) {
		return false;
	}
	try {
		const parsed = new URL(url, window.location.origin);
		return /(^|\.)youtube\.com$|(^|\.)youtube-nocookie\.com$|(^|\.)vimeo\.com$/.test(
			parsed.hostname
		);
	} catch {
		return false;
	}
}

function strl_sanitize_is_allowed_attr(tag, attr) {
	const name = attr.toLowerCase();
	if (name.startsWith('on') || name.startsWith('xmlns')) {
		return false;
	}
	if (name === 'style') {
		return false;
	}
	if (STRL_SANITIZE_URI_ATTRS.has(name)) {
		return true;
	}
	if (STRL_SANITIZE_GLOBAL_ATTRS.has(name)) {
		return true;
	}
	const tagAttrs = STRL_SANITIZE_TAG_ATTRS[tag];
	return tagAttrs ? tagAttrs.includes(name) : false;
}

function strl_sanitize_node(node) {
	const children = Array.from(node.childNodes);
	for (let i = 0; i < children.length; i++) {
		const child = children[i];
		if (child.nodeType === Node.COMMENT_NODE) {
			node.removeChild(child);
			continue;
		}
		if (child.nodeType !== Node.ELEMENT_NODE) {
			continue;
		}

		const tag = child.tagName.toLowerCase();
		if (!STRL_SANITIZE_ALLOWED_TAGS.has(tag)) {
			while (child.firstChild) {
				node.insertBefore(child.firstChild, child);
			}
			node.removeChild(child);
			continue;
		}

		const attrs = Array.from(child.attributes);
		for (let a = 0; a < attrs.length; a++) {
			const attr = attrs[a];
			const name = attr.name.toLowerCase();
			const value = attr.value;
			if (!strl_sanitize_is_allowed_attr(tag, name)) {
				child.removeAttribute(attr.name);
				continue;
			}
			if (STRL_SANITIZE_URI_ATTRS.has(name) && !strl_sanitize_is_safe_url(value)) {
				child.removeAttribute(attr.name);
				continue;
			}
			if (tag === 'iframe' && name === 'src' && !strl_sanitize_is_allowed_iframe_src(value)) {
				child.removeAttribute(attr.name);
			}
		}

		if (tag === 'a' && child.getAttribute('target') === '_blank') {
			const rel = child.getAttribute('rel') || '';
			if (!/\bnoopener\b/.test(rel)) {
				child.setAttribute('rel', `${rel} noopener noreferrer`.trim());
			}
		}

		strl_sanitize_node(child);
	}
}

export function strl_sanitize_html(html) {
	if (!html || typeof html !== 'string') {
		return '';
	}

	const doc = new DOMParser().parseFromString(html, 'text/html');
	strl_sanitize_node(doc.body);
	return doc.body.innerHTML;
}
